/* import __COLOCATED_TEMPLATE__ from './legend-area.hbs'; */
/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-computed-properties-in-native-classes */
import Component from '@ember/component';
import { inject as service } from '@ember/service';
import { computed, action } from '@ember/object';
import $ from 'jquery';

$.fn.exists = function () {
  return this.length !== 0;
};

var LegendItem = function (id, htmlId, displayName, color, first) {
  this.id = id;
  this.htmlId = htmlId;
  this.displayName = displayName;
  this.color = color;
  this.first = first;
  this.style = '';
};

var populateLegend = function (intl, type, colors) {
  var legendItems = [],
    operatingRange = new LegendItem(
      1,
      'operating-range',
      intl.t('legend.operatingRange'),
      colors.inputConfigurationPolygon,
      true,
    );
  legendItems.push(operatingRange);

  switch (type.toLowerCase()) {
    case '3amp':
    case '3ampclamped':
      {
        let inputPin = new LegendItem(2, 'input-node', intl.t('legend.inputLimits'), colors.preAmplifierInputPolygon),
          outputPin = new LegendItem(
            3,
            'output-node',
            intl.t('legend.outputLimits'),
            colors.subtractorInputOutputPolygon,
          ),
          internalNode = new LegendItem(
            4,
            'internal-node',
            intl.t('legend.internalLimits'),
            colors.preAmplifierOutput3AmpPolygon,
          );
        legendItems.push(inputPin, outputPin, internalNode);
      }
      break;
    case '2amp':
      {
        let inputPin = new LegendItem(2, 'input-node', intl.t('legend.inputLimits'), colors.preAmplifierInputPolygon),
          outputPin = new LegendItem(
            5,
            'output-A1-node',
            intl.t('legend.outputPinA1'),
            colors.outputAmplifier2AmpPolygon,
          );
        legendItems.push(inputPin, outputPin);
      }
      break;
    case 'current':
      {
        let inputPin = new LegendItem(2, 'input-node', intl.t('legend.inputLimits'), colors.preAmplifierInputPolygon),
          feedbackPin = new LegendItem(7, 'feedback-node', intl.t('legend.feedbackLimits'), colors.feedback1),
          outputPin = new LegendItem(6, 'output-node', intl.t('legend.outputLimits'), colors.outputPinBoundry),
          diffPin = new LegendItem(8, 'diff-node', intl.t('legend.differentailLimits'), colors.feedback2);
        legendItems.push(inputPin, feedbackPin, outputPin, diffPin);
      }
      break;
    case 'difftia-pgia':
    case 'diffpgia':
      {
        let inputPin = new LegendItem(2, 'input-node', intl.t('legend.inputLimits'), colors.preAmplifierInputPolygon),
          outputPin = new LegendItem(
            3,
            'output-node',
            intl.t('legend.outputLimits'),
            colors.subtractorInputOutputPolygon,
          );
        legendItems.push(inputPin, outputPin);
      }
      break;
    case 'diff3amppgia':
      {
        let inputPin = new LegendItem(2, 'input-node', intl.t('legend.inputLimits'), colors.preAmplifierInputPolygon),
          outputPin = new LegendItem(
            3,
            'output-node',
            intl.t('legend.outputLimits'),
            colors.subtractorInputOutputPolygon,
          ),
          internalNode = new LegendItem(
            4,
            'internal-node',
            intl.t('legend.internalLimits'),
            colors.preAmplifierOutput3AmpPolygon,
          );
        legendItems.push(inputPin, outputPin, internalNode);
      }
      break;
    default:
      break;
  }

  return legendItems;
};

////////////////////////////////////////////////////////////////////////////////////
// legend-area - Component for Diamond graph legend                               //
////////////////////////////////////////////////////////////////////////////////////

export default class LegendArea extends Component {
  tagName = '';
  @service('aditools-analytics') analytics;
  @service intl;
  isLegendOpened = false;
  lastFocusBeforeLegend = null;

  ////////////////////////////////////////////////////////////////////////////////
  // Computed Values                                                            //
  ////////////////////////////////////////////////////////////////////////////////

  @computed('selectedPart', 'legendColors') get legendItems() {
    return populateLegend(this.intl, this.selectedPart.inAmpType, this.legendColors);
  }

  ////////////////////////////////////////////////////////////////////////////////
  // Component Actions                                                          //
  ////////////////////////////////////////////////////////////////////////////////

  @action insertedLegend() {
    this.set('lastFocusBeforeLegend', document.activeElement);
  }

  @action destroyedLegend() {
    if (this.lastFocusBeforeLegend && this.lastFocusBeforeLegend.focus) {
      //SVG focusable elements don't have a focus method() in IE & Edge
      this.lastFocusBeforeLegend.focus();
    }
  }

  @action legendOpen() {
    this.set('isLegendOpened', true);
    this.analytics.setWebEvent(this.toolName, 'legendViewed', '');
  }

  @action legendClose() {
    this.set('isLegendOpened', false);
  }
}
